import {
  AppPublicLayout,
  AppPublicPage,
  PublicDocument,
} from "./../layout";

export function DatenschutzApp() {
  return (
    <AppPublicLayout>
      <AppPublicPage width="narrow">
        <PublicDocument>
          <h1>Datenschutzerklärung</h1>

          <p className="lead">
            Informationen zur Verarbeitung personenbezogener Daten bei der
            Nutzung der Logami Android-App.
          </p>

          <p>Stand: 09. Juli 2026</p>

          <h2>1. Datenschutz auf einen Blick</h2>

          <h3>Allgemeine Hinweise</h3>

          <p>
            Die folgenden Hinweise geben einen Überblick darüber, was mit
            personenbezogenen Daten passiert, wenn Sie die Logami Android-App
            nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können.
          </p>

          <p>
            Logami ist eine B2B-Anwendung zur Organisation und Dokumentation von
            Aufträgen, Einsatzorten, Arbeitszeiten, Fotos, Notizen,
            Kundensignaturen und damit verbundenen Arbeitsabläufen.
          </p>

          <h3>Wer ist verantwortlich?</h3>

          <p>
            Verantwortlich für die Datenverarbeitung ist die unten genannte
            verantwortliche Stelle. Soweit Logami von einem Unternehmen, Betrieb
            oder einer Organisation zur Verwaltung eigener Mitarbeiter, Kunden,
            Einsatzorte und Aufträge eingesetzt wird, kann dieses Unternehmen
            für bestimmte Datenverarbeitungen selbst verantwortlich sein. In
            diesen Fällen verarbeitet Logami personenbezogene Daten im Auftrag
            dieses Unternehmens.
          </p>

          <h3>Welche Daten werden verarbeitet?</h3>

          <p>
            Bei der Nutzung der App können insbesondere Accountdaten,
            Benutzerdaten, Mitarbeiterdaten, Kundendaten, Auftragsdaten,
            Auftragsereignisse, Fotos, Notizen, Kundensignaturen,
            Standortdaten und technische Diagnose- oder Fehlerdaten verarbeitet
            werden.
          </p>

          <h3>Wofür nutzen wir die Daten?</h3>

          <p>
            Die Daten werden genutzt, um die Logami-App bereitzustellen,
            Benutzer zu authentifizieren, Aufträge zu planen und zu
            dokumentieren, Arbeitszeiten und Ereignisse zu erfassen, technische
            Fehler zu analysieren und die Sicherheit sowie Stabilität der App zu
            gewährleisten.
          </p>

          <h3>Welche Rechte haben Sie?</h3>

          <p>
            Sie haben im Rahmen der gesetzlichen Voraussetzungen insbesondere
            das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
            Verarbeitung, Datenübertragbarkeit, Widerspruch sowie Widerruf einer
            erteilten Einwilligung. Außerdem steht Ihnen ein Beschwerderecht bei
            einer zuständigen Datenschutzaufsichtsbehörde zu.
          </p>

          <h2>2. Verantwortliche Stelle</h2>

          <p>Verantwortliche Stelle für die Datenverarbeitung ist:</p>

          <address>
            Lukas Ottweiler
            <br />
            Logami
            <br />
            c/o MDC#986
            <br />
            Welserstraße 3
            <br />
            87463 Dietmannsried
            <br />
            Deutschland
          </address>

          <p>
            E-Mail:{" "}
            <a href="mailto:kontakt@logami.de">kontakt@logami.de</a>
          </p>

          <p>
            Verantwortliche Stelle ist die natürliche oder juristische Person,
            die allein oder gemeinsam mit anderen über die Zwecke und Mittel der
            Verarbeitung von personenbezogenen Daten entscheidet.
          </p>

          <h2>3. Nutzung der App und Kontoanlage</h2>

          <p>
            Die Logami Android-App ermöglicht keine eigenständige Erstellung
            eines neuen Benutzerkontos innerhalb der App.
          </p>

          <p>
            Benutzer erhalten Zugriff auf Logami in der Regel durch eine
            Einladung des jeweiligen Unternehmens oder Account-Inhabers. Die
            Annahme der Einladung, die Vergabe von Zugangsdaten sowie die
            Zustimmung zu Nutzungsbedingungen und Datenschutzhinweisen erfolgen
            außerhalb der App über die Logami-Webanwendung.
          </p>

          <p>
            In der App können sich berechtigte Benutzer mit ihren Zugangsdaten
            anmelden und die für sie freigeschalteten Funktionen nutzen.
          </p>

          <h2>4. Welche Daten verarbeitet werden</h2>

          <h3>Account- und Benutzerdaten</h3>

          <p>Hierzu gehören insbesondere:</p>

          <ul>
            <li>Name</li>
            <li>E-Mail-Adresse</li>
            <li>Unternehmens- oder Account-Zugehörigkeit</li>
            <li>Rolle und Berechtigungen innerhalb eines Logami-Accounts</li>
            <li>technische Sitzungs- und Authentifizierungsdaten</li>
          </ul>

          <h3>Mitarbeiter- und Monteurdaten</h3>

          <p>
            Soweit diese durch den Account-Inhaber oder berechtigte Benutzer
            gepflegt werden, können insbesondere folgende Daten verarbeitet
            werden:
          </p>

          <ul>
            <li>Name</li>
            <li>Anzeigename oder bevorzugter Name</li>
            <li>E-Mail-Adresse</li>
            <li>optional: Telefonnummer</li>
            <li>Zuordnung zu Aufträgen, Teams oder Einsätzen</li>
          </ul>

          <h3>Kundendaten</h3>

          <p>
            Zur Durchführung und Dokumentation von Aufträgen können insbesondere
            folgende Kundendaten verarbeitet werden:
          </p>

          <ul>
            <li>Name</li>
            <li>Adresse</li>
            <li>optional: E-Mail-Adresse</li>
            <li>optional: Telefonnummer</li>
            <li>zugehörige Aufträge, Einsatzorte und Notizen</li>
          </ul>

          <h3>Auftrags- und Einsatzdaten</h3>

          <p>
            Bei der Nutzung von Logami können insbesondere folgende
            auftragsbezogene Daten verarbeitet werden:
          </p>

          <ul>
            <li>Auftragsadresse und Einsatzort</li>
            <li>Auftragsbeschreibung</li>
            <li>Notizen</li>
            <li>geplanter Startzeitpunkt</li>
            <li>Status des Auftrags</li>
            <li>zugeordnete Mitarbeiter oder Monteure</li>
            <li>Fotos und sonstige Dokumentationen zum Auftrag</li>
          </ul>

          <h3>Ereignisse während eines Auftrags</h3>

          <p>
            Während der Bearbeitung eines Auftrags können Benutzer Ereignisse
            erfassen, insbesondere:
          </p>

          <ul>
            <li>Startzeit</li>
            <li>Stoppzeit</li>
            <li>Pausenzeiten</li>
            <li>Notizen</li>
            <li>Fotos</li>
            <li>Standortdaten, sofern aktiviert</li>
            <li>Kundensignatur</li>
            <li>sonstige Nachweise zur Auftragsdurchführung</li>
          </ul>

          <h2>5. Standortdaten</h2>

          <p>
            Die Logami-App kann Standortdaten verarbeiten, wenn diese Funktion
            durch den Benutzer beziehungsweise den Account entsprechend
            aktiviert ist und die erforderliche Berechtigung auf dem Gerät
            erteilt wurde.
          </p>

          <p>
            Die Standorterfassung dient der Dokumentation von Auftragseinsätzen,
            Arbeitsereignissen und Einsatzverläufen. Sie dient nicht der Werbung
            oder der Erstellung von Bewegungsprofilen zu Werbezwecken.
          </p>

          <p>
            Je nach Einstellung kann die Standorterfassung deaktiviert sein oder
            in einem der folgenden Modi erfolgen:
          </p>

          <ul>
            <li>keine Standorterfassung</li>
            <li>
              Standorterfassung nur bei bestimmten Ereignissen, zum Beispiel
              Start, Stopp oder Auftragsereignis
            </li>
            <li>
              fortlaufende Standorterfassung nur während eines aktiven Auftrags
            </li>
          </ul>

          <p>
            Eine fortlaufende Standorterfassung erfolgt nur während eines
            aktiven Auftrags. Außerhalb eines aktiven Auftrags findet keine
            fortlaufende Standorterfassung statt.
          </p>

          <p>
            Benutzer können die Standortberechtigung jederzeit über die
            Systemeinstellungen ihres Android-Geräts entziehen. Je nach
            betrieblicher Einstellung kann dadurch die Funktionalität der App
            eingeschränkt sein.
          </p>

          <h2>6. Fotos, Kamera und Dateien</h2>

          <p>
            Die Logami-App kann Zugriff auf Kamera, Fotos oder Dateien des
            Geräts anfordern, soweit dies für die Erfassung und Dokumentation
            von Aufträgen erforderlich ist.
          </p>

          <p>
            Fotos und Dateien werden nur verarbeitet, wenn Benutzer diese aktiv
            aufnehmen, auswählen oder hochladen. Sie können insbesondere zur
            Dokumentation von Arbeiten, Schäden, Arbeitsergebnissen oder
            sonstigen auftragsbezogenen Vorgängen verwendet werden.
          </p>

          <h2>7. Kundensignaturen</h2>

          <p>
            Im Rahmen der Auftragsdokumentation kann eine Kundensignatur erfasst
            werden. Diese dient dem Nachweis der erbrachten Leistung, der
            Abnahme oder der Dokumentation eines auftragsbezogenen Ereignisses.
          </p>

          <p>
            Die Signatur wird dem jeweiligen Auftrag zugeordnet und kann für
            interne Nachweise, Kundenkommunikation, Abrechnung oder rechtliche
            Dokumentationszwecke verwendet werden.
          </p>

          <h2>8. Diagnose-, Fehler- und Sicherheitsdaten</h2>

          <p>
            Zur Gewährleistung der technischen Stabilität, Sicherheit und
            Fehleranalyse verarbeitet Logami technische Daten. Hierzu können
            insbesondere gehören:
          </p>

          <ul>
            <li>App-Version</li>
            <li>
              Geräteinformationen, zum Beispiel Modell, Betriebssystemversion
              und Spracheinstellungen
            </li>
            <li>Zeitpunkt von App-Abstürzen oder Fehlern</li>
            <li>technische Fehlermeldungen und Stacktraces</li>
            <li>technische Sitzungs- oder Installationskennungen</li>
            <li>
              Server- und Anwendungsprotokolle, zum Beispiel Zeitpunkt,
              aufgerufene Schnittstelle, Statuscode, Dauer der Anfrage und
              Fehlertyp
            </li>
          </ul>

          <p>
            Logami verwendet für Absturzberichte Firebase Crashlytics von
            Google. Crashlytics hilft uns, App-Abstürze zu erkennen, zu
            analysieren und die Stabilität der App zu verbessern.
          </p>

          <p>
            Die übrige technische Telemetrie wird selbst betrieben und auf
            unserer eigenen Serverinfrastruktur verarbeitet.
          </p>

          <h2>9. Zwecke der Verarbeitung</h2>

          <p>
            Die Verarbeitung personenbezogener Daten erfolgt insbesondere zu
            folgenden Zwecken:
          </p>

          <ul>
            <li>Bereitstellung der Logami-App und der Logami-Dienste</li>
            <li>Anmeldung und Authentifizierung von Benutzern</li>
            <li>Verwaltung von Accounts, Rollen und Berechtigungen</li>
            <li>Planung, Durchführung und Dokumentation von Aufträgen</li>
            <li>Erfassung von Arbeitszeiten, Pausen und Auftragsereignissen</li>
            <li>
              Dokumentation von Fotos, Notizen, Standorten und Kundensignaturen
            </li>
            <li>
              Kommunikation und Nachvollziehbarkeit innerhalb eines
              Logami-Accounts
            </li>
            <li>technische Fehleranalyse und Verbesserung der App-Stabilität</li>
            <li>
              Schutz vor Missbrauch, unberechtigtem Zugriff und
              Sicherheitsvorfällen
            </li>
            <li>Erfüllung vertraglicher und gesetzlicher Pflichten</li>
          </ul>

          <h2>10. Rechtsgrundlagen der Verarbeitung</h2>

          <p>
            Die Verarbeitung erfolgt, je nach Zweck, auf Grundlage der folgenden
            Rechtsgrundlagen:
          </p>

          <ul>
            <li>
              Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur Erfüllung
              eines Vertrags oder zur Durchführung vorvertraglicher Maßnahmen
              erforderlich ist
            </li>
            <li>
              Art. 6 Abs. 1 lit. f DSGVO, soweit die Verarbeitung zur
              Bereitstellung, Sicherheit, Fehleranalyse und Verbesserung der App
              erforderlich ist und keine überwiegenden Interessen der
              betroffenen Personen entgegenstehen
            </li>
            <li>
              Art. 6 Abs. 1 lit. a DSGVO, soweit eine Einwilligung eingeholt
              wird, insbesondere bei optionalen Funktionen oder
              Geräteberechtigungen
            </li>
            <li>
              Art. 6 Abs. 1 lit. c DSGVO, soweit eine Verarbeitung zur
              Erfüllung gesetzlicher Pflichten erforderlich ist
            </li>
          </ul>

          <p>
            Soweit Logami personenbezogene Daten im Auftrag eines Unternehmens
            verarbeitet, erfolgt die Verarbeitung zusätzlich auf Grundlage des
            zwischen Logami und dem jeweiligen Unternehmen geschlossenen
            Vertrags über Auftragsverarbeitung.
          </p>

          <h2>11. Empfänger personenbezogener Daten</h2>

          <p>
            Personenbezogene Daten können, soweit erforderlich, folgenden
            Empfängern zugänglich gemacht werden:
          </p>

          <ul>
            <li>dem jeweiligen Account-Inhaber beziehungsweise Unternehmen</li>
            <li>
              berechtigten Benutzern innerhalb desselben Logami-Accounts
            </li>
            <li>technischen Dienstleistern und Auftragsverarbeitern</li>
            <li>Hosting- und Infrastruktur-Dienstleistern</li>
            <li>Google Firebase Crashlytics zur Analyse von App-Abstürzen</li>
            <li>
              Behörden oder sonstigen Stellen, soweit eine gesetzliche
              Verpflichtung besteht
            </li>
          </ul>

          <p>
            Eine Weitergabe personenbezogener Daten zu Werbezwecken erfolgt
            nicht.
          </p>

          <h2>12. Hosting und Infrastruktur</h2>

          <p>
            Logami nutzt zur Bereitstellung der Dienste Serverinfrastruktur bei
            Hetzner.
          </p>

          <p>
            Anbieter ist die Hetzner Online GmbH, Industriestr. 25, 91710
            Gunzenhausen, Deutschland.
          </p>

          <p>
            Details entnehmen Sie der Datenschutzerklärung von Hetzner:{" "}
            <a
              href="https://www.hetzner.com/de/legal/privacy-policy/"
              target="_blank"
              rel="noreferrer"
            >
              https://www.hetzner.com/de/legal/privacy-policy/
            </a>
            .
          </p>

          <p>
            Die Verarbeitung erfolgt zur zuverlässigen, sicheren und performanten
            Bereitstellung der Logami-Dienste. Mit eingesetzten
            Auftragsverarbeitern werden, soweit erforderlich, Verträge über
            Auftragsverarbeitung geschlossen.
          </p>

          <h2>13. Firebase Crashlytics</h2>

          <p>
            Die Logami-App verwendet Firebase Crashlytics, einen Dienst von
            Google, zur Erfassung und Analyse von App-Abstürzen und technischen
            Fehlern.
          </p>

          <p>
            Anbieter ist Google Ireland Limited, Gordon House, Barrow Street,
            Dublin 4, Irland. Je nach Verarbeitung kann auch Google LLC, USA,
            beteiligt sein.
          </p>

          <p>
            Crashlytics kann technische Informationen zum Gerät, zur App-Version,
            zum Betriebssystem, zum Zeitpunkt des Absturzes, zu technischen
            Fehlerdetails und zu Installationskennungen verarbeiten. Diese Daten
            helfen uns, Abstürze zu verstehen und Fehler zu beheben.
          </p>

          <p>
            Weitere Informationen finden Sie in den Datenschutzhinweisen von
            Firebase:{" "}
            <a
              href="https://firebase.google.com/support/privacy"
              target="_blank"
              rel="noreferrer"
            >
              https://firebase.google.com/support/privacy
            </a>
            .
          </p>

          <p>
            Die Verarbeitung erfolgt auf Grundlage unseres berechtigten
            Interesses an einer stabilen und sicheren App gemäß Art. 6 Abs. 1
            lit. f DSGVO, soweit keine Einwilligung erforderlich ist. Soweit
            eine Einwilligung erforderlich ist, erfolgt die Verarbeitung auf
            Grundlage von Art. 6 Abs. 1 lit. a DSGVO.
          </p>

          <h2>14. Speicherdauer</h2>

          <p>
            Personenbezogene Daten werden nur so lange gespeichert, wie dies für
            die jeweiligen Zwecke erforderlich ist.
          </p>

          <p>
            Account-, Benutzer-, Kunden-, Auftrags- und Dokumentationsdaten
            werden grundsätzlich für die Dauer der Nutzung des jeweiligen
            Logami-Accounts gespeichert. Sie können durch berechtigte Benutzer
            oder den Account-Inhaber gelöscht werden, soweit keine gesetzlichen,
            vertraglichen oder berechtigten Gründe für eine weitere Speicherung
            bestehen.
          </p>

          <p>
            Auftragsbezogene Daten, Fotos, Notizen, Zeiten, Standortdaten und
            Kundensignaturen können aufgrund betrieblicher Dokumentationspflichten,
            Nachweispflichten oder gesetzlicher Aufbewahrungsfristen länger
            gespeichert werden.
          </p>

          <p>
            Technische Diagnose-, Sicherheits- und Serverprotokolle werden nur so
            lange gespeichert, wie sie für Sicherheit, Fehleranalyse und Betrieb
            erforderlich sind, und anschließend gelöscht oder anonymisiert.
          </p>

          <p>
            Wenn Sie ein berechtigtes Löschersuchen stellen oder eine
            Einwilligung widerrufen, löschen wir die betroffenen Daten, sofern
            keine rechtlich zulässigen Gründe für eine weitere Speicherung
            bestehen.
          </p>

          <h2>15. Rechte betroffener Personen</h2>

          <p>
            Betroffene Personen haben im Rahmen der gesetzlichen Voraussetzungen
            insbesondere folgende Rechte:
          </p>

          <ul>
            <li>Recht auf Auskunft</li>
            <li>Recht auf Berichtigung</li>
            <li>Recht auf Löschung</li>
            <li>Recht auf Einschränkung der Verarbeitung</li>
            <li>Recht auf Datenübertragbarkeit</li>
            <li>Recht auf Widerspruch gegen bestimmte Verarbeitungen</li>
            <li>
              Recht auf Widerruf einer erteilten Einwilligung mit Wirkung für
              die Zukunft
            </li>
            <li>
              Recht auf Beschwerde bei einer zuständigen
              Datenschutzaufsichtsbehörde
            </li>
          </ul>

          <p>
            Zur Ausübung Ihrer Rechte können Sie sich jederzeit an uns wenden:{" "}
            <a href="mailto:kontakt@logami.de">kontakt@logami.de</a>.
          </p>

          <p>
            Soweit Daten im Auftrag eines Unternehmens verarbeitet werden, kann
            es erforderlich sein, dass wir Anfragen an den jeweiligen
            Account-Inhaber beziehungsweise Arbeitgeber weiterleiten oder mit
            diesem abstimmen.
          </p>

          <h2>16. Android-Berechtigungen</h2>

          <p>
            Die Logami-App kann je nach Nutzung folgende Android-Berechtigungen
            anfordern:
          </p>

          <ul>
            <li>Internetzugriff zur Verbindung mit den Logami-Diensten</li>
            <li>
              Kamera zur Aufnahme von Fotos für die Auftragsdokumentation
            </li>
            <li>
              Zugriff auf Fotos oder Dateien zum Hochladen von
              Dokumentationsmaterial
            </li>
            <li>
              Standortberechtigung zur Erfassung von Einsatz- oder
              Ereignisstandorten, sofern aktiviert
            </li>
            <li>
              Benachrichtigungen, sofern diese für auftragsbezogene Hinweise
              oder Systeminformationen genutzt werden
            </li>
          </ul>

          <p>
            Berechtigungen können jederzeit über die Einstellungen des
            Android-Geräts geändert oder entzogen werden. Einzelne Funktionen
            der App können dadurch eingeschränkt sein.
          </p>

          <h2>17. Datensicherheit</h2>

          <p>
            Wir setzen technische und organisatorische Maßnahmen ein, um
            personenbezogene Daten gegen Verlust, Missbrauch, unberechtigten
            Zugriff, Veränderung oder Offenlegung zu schützen.
          </p>

          <p>
            Die Kommunikation zwischen App und Server erfolgt verschlüsselt. Der
            Zugriff auf Logami-Daten ist rollen- und berechtigungsbasiert
            eingeschränkt.
          </p>

          <p>
            Ein vollständiger Schutz vor allen Risiken der Datenübertragung über
            das Internet kann jedoch nicht garantiert werden.
          </p>

          <h2>18. Änderungen dieser Datenschutzerklärung</h2>

          <p>
            Wir können diese Datenschutzerklärung anpassen, wenn sich die App,
            die eingesetzten Dienste, rechtliche Anforderungen oder unsere
            Datenverarbeitung ändern.
          </p>

          <p>
            Die jeweils aktuelle Version ist über unsere Website und innerhalb
            der App abrufbar.
          </p>
        </PublicDocument>
      </AppPublicPage>
    </AppPublicLayout>
  );
}
